import EsqueciMinhaSenhaGex from "@/views/auth/EsqueciMinhaSenhaGex.vue";
import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import LoginLayout from "@/layouts/LoginLayout.vue";
import HomeView from "@/views/HomeView.vue";
import CadastroView from "@/views/auth/CadastroView.vue";
import ListaUsuariosView from "@/views/usuarios/ListaUsuariosView.vue";
import loginGexView from "@/views/auth/loginGexView.vue";
import LoginSigaaView from "@/views/auth/LoginSigaaView.vue";

import { jwtDecode } from "jwt-decode";
import AcaoView from "@/views/acoes/AcaoView.vue";
import MenuAcoesView from "@/views/acoes/MenuAcoesView.vue";
import NoticiaView from "@/views/noticias/NoticiaView.vue";
import MenuAtividadesComponent from "@/components/atividades/MenuAtividadesComponent.vue";
import MenuNoticiasView from "@/views/noticias/MenuNoticiasView.vue";
import MenuCertificadosEDeclaracoesView from "@/views/acoes/MenuCertificadosEDeclaracoesView.vue";
import MenuTarefasAcao from "@/components/tarefas/MenuTarefasAcao.vue";
import CentralDaCoordenacao from "@/views/acoes/CentralDaCoordenacao.vue";
import AtividadeView from "@/views/atividades/AtividadeView.vue";
import FormCadastroAtividade from "@/components/atividades/FormCadastroAtividade.vue";
import FormCadastroEncontro from "@/components/encontros/FormCadastroEncontro.vue";
import FormCadastroTarefa from "@/components/tarefas/FormCadastroTarefa.vue";
import TarefaView from "@/views/tarefas/TarefaView.vue";
import userInfos from "@/utils/userInfos"; // Importar o userInfos
import PerfilUsuarioView from "@/views/usuarios/PerfilUsuarioView.vue";
import FormFrequenciaEncontro from "@/components/encontros/FormFrequenciaEncontro.vue";
import ResultadosView from "@/views/ResultadosView.vue";
import AtividadesCentralDoCoordenador from "@/components/central-coordenador/AtividadesCentralDoCoordenador.vue";
import TarefasCentralDoCoordenador from "@/components/central-coordenador/TarefasCentralDoCoordenador.vue";
import CadastroNoticia from "@/views/noticias/CadastroNoticia.vue";
import EditarNoticia from "@/views/noticias/EditarNoticia.vue";
import EditarEmail from "@/views/auth/EditarEmail.vue";
import NoticiasCentralCoordenacao from "@/components/central-coordenador/NoticiasCentralCoordenacao.vue";
import CentralPrex from "@/views/prex/CentralPrex.vue";
import NoticiaViewPrex from "@/views/noticias/NoticiaViewPrex.vue";
import MenuVagasComponent from "@/components/vagas/MenuVagasComponent.vue";
import VagasView from "@/views/vagas/VagasView.vue";
import FormVagasView from "@/views/vagas/FormVagasView.vue";

import InformacoesAcaoView from "@/views/acoes/InformacoesAcaoView.vue";
import AjudaView from "@/views/ajudaView.vue";

import MenuParceriaView from "@/components/MenuParceriaView.vue";
import MenuParceriasComponent from "@/components/parcerias/MenuParceriasComponent.vue";
//import ParceriasView from "@/views/parcerias/ParceriasView.vue";
import FormParceriaInterna from "@/components/parcerias/FormParceriaInterna.vue";
import FormParceriaExterna from "@/components/parcerias/FormParceriaExterna.vue";

// Você precisará criar estes componentes ou usar placeholders temporários
const DeclaracoesAcao = {
  template: "<div>Minhas Declarações/Certificados</div>",
};

const routes = [
  {
    path: "/",
    name: "home",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "home-page",
        component: HomeView,
        beforeEnter: (to, from, next) => {
          if (to.query.token) {
            next({ name: "recuperar-senha", query: { token: to.query.token } });
          } else {
            next();
          }
        },
      },
      {
        path: "/central-ajuda",
        name: "central-ajuda",
        component: AjudaView,
      },
      {
        path: "/resultados",
        name: "resultados",
        component: ResultadosView,
      },
      {
        path: "/home-noticia/:noticiaId",
        name: "home-noticia",
        component: NoticiaView,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/home-atividade/:atividadeId",
        name: "home-atividade",
        component: AtividadeView,
        props: (route) => ({
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/suas-acoes",
        name: "suas-acoes",
        component: MenuAcoesView,
      },
      {
        path: "/Atividades",
        name: "atividades",
        component: MenuAtividadesComponent,
      },
      {
        path: "/Parcerias",
        name: "parcerias",
        component: MenuParceriasComponent,
      },
      {
        path: "/Parcerias/:parceriaId",
        name: "ParceriaView",
        component: () => import("@/views/parcerias/ParceriaView.vue"),
      },
      {
        path: "Atividades/:atividadeId",
        name: "AtividadeView",
        component: AtividadeView,
        props: (route) => ({
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },

      {
        path: "/acao/:id/Parcerias/Formulario-parceria-externa",
        name: "formulario-parceria-externa",
        component: FormParceriaExterna,
        props: (route) => ({
          acaoId: route.params.id,
        }),
      },
      {
        path: "/acao/:id/Parcerias/Formulario-parceria-interna",
        name: "formulario-parceria-interna",
        component: FormParceriaInterna,
        props: (route) => ({
          acaoId: route.params.id,
        }),
      },
      {
        path: "/vagas",
        name: "vagas",
        component: MenuVagasComponent,
      },
      {
        path: "/Vaga/:vagaId",
        name: "VagasView",
        component: VagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/Vaga/:vagaId",
        name: "VagasViewAcao",
        component: VagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-vaga",
        name: "cadastrar-vaga",
        component: FormVagasView,
      },
      {
        path: "/acao/:id/editar-vaga/:vagaId",
        name: "editar-vaga",
        component: FormVagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/editar-vaga/:vagaId",
        name: "editar-vaga-direto",
        component: FormVagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/Atividades/:atividadeId",
        name: "atividade-acao-view",
        children: [
          {
            path: "",
            name: "atividade-acao",
            component: AtividadeView,
            props: (route) => ({
              atividadeId: route.params.atividadeId,
              ...route.params,
            }),
          },
          {
            path: "cadastro-frequencia/:encontroId",
            name: "cadastro-frequencia-atividade",
            component: FormFrequenciaEncontro,
            props: (route) => ({
              atividadeId: route.params.atividadeId,
              encontroId: route.params.encontroId,
              ...route.params,
            }),
          },
        ],
      },
      {
        path: "/Noticias",
        name: "noticias",
        component: MenuNoticiasView,
      },
      {
        path: "/noticias/:noticiaId",
        name: "NoticiaView",
        component: NoticiaView,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/noticias/:noticiaId",
        name: "noticia-acao-view",
        component: NoticiaView,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },

      {
        path: "/Meus-Certificados-e-Declaracoes",
        name: "certificados-declaracoes",
        component: MenuCertificadosEDeclaracoesView,
      },
      {
        path: "lista-usuarios",
        name: "lista-usuarios",
        component: ListaUsuariosView,
      },
      {
        path: "perfil",
        name: "perfil",
        component: PerfilUsuarioView,
      },
      {
        path: "central-prex",
        name: "central-prex",
        component: CentralPrex,
        beforeEnter: (to, from, next) => {
          checkUsuarioPrex(to, from, next);
        },
      },
      {
        path: "central-prex/noticia/:noticiaId",
        name: "noticia-prex-view",
        component: NoticiaViewPrex,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          mostrarBotoes: true,
        }),
      },
      // ROTA PRINCIPAL DA AÇÃO COM ROTAS ANINHADAS
      {
        path: "/acao/:id",
        name: "AcaoView",
        component: AcaoView,
        props: true,
        children: [
          {
            path: "",
            name: "acao-default",
            redirect: { name: "acao-informacoes" },
          },
          {
            path: "atividades",
            name: "acao-atividades",
            component: MenuAtividadesComponent,
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "noticias",
            name: "acao-noticias",
            component: MenuNoticiasView,
            props: (route) => ({
              acaoId: route.params.id,
              isCoordenador: route.meta.isCoordenador,
            }),
          },
          {
            path: "tarefas",
            name: "acao-tarefas",
            component: MenuTarefasAcao,
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "cadastrar-tarefa",
            name: "cadastrar-tarefa",
            component: FormCadastroTarefa,
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "parcerias",
            name: "acao-parcerias",
            component: MenuParceriaView,
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
          },

          {
            path: "informacoes",
            name: "acao-informacoes",
            component: InformacoesAcaoView,
            props: true,
          },
          {
            path: "declaracoes",
            name: "acao-declaracoes",
            component: DeclaracoesAcao,
            props: true,
          },
          {
            path: "vagas",
            name: "acao-vagas",
            component: MenuVagasComponent,
          },
          {
            path: "dashboard",
            name: "acao-dashboard",
            component: () => import("@/views/DashBoard.vue"),
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "central-coordenacao",
            name: "acao-central-coordenacao",
            component: CentralDaCoordenacao,
            redirect: { name: "atividades-central-coordenacao" },
            children: [
              {
                path: "Atividades",
                name: "atividades-central-coordenacao",
                component: AtividadesCentralDoCoordenador,
                props: (route) => ({
                  acaoId: route.params.id,
                  ...route.params,
                }),
              },
              {
                path: "Noticias",
                name: "noticias-central-coordenacao",
                component: NoticiasCentralCoordenacao,
                props: (route) => ({
                  acaoId: route.params.id,
                  ...route.params,
                }),
              },
              {
                path: "Noticias/:noticiaId",
                name: "aceitar-noticia-central-coordenacao",
                component: NoticiaView,
                props: (route) => ({
                  noticiaId: route.params.noticiaId,
                  id: route.params.id,
                  isAcceptance: true,
                }),
              },
              {
                path: "Tarefas",
                name: "tarefas-central-coordenacao",
                component: TarefasCentralDoCoordenador,
                props: (route) => ({
                  acaoId: route.params.id,
                  ...route.params,
                }),
              },
            ],
            props: (route) => ({
              acaoId: route.params.id,
              ...route.params,
            }),
            beforeEnter: (to, from, next) => {
              checkCoordenador(to, from, next);
            },
          },
        ],
      },
      {
        path: "/acao/:id/cadastrar-noticia",
        name: "cadastrar-noticia",
        component: CadastroNoticia,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeObjeto: window.history.state?.atividadeObjeto || null,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-atividade",
        name: "cadastrar-atividade",
        component: FormCadastroAtividade,
        props: (route) => ({
          acaoId: route.params.id,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-atividade/encontros",
        name: "cadastrar-encontros-atividade",
        component: FormCadastroEncontro,
        props: (route) => ({
          acaoId: route.params.id,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/editar-atividade/:atividadeId",
        name: "editar-atividade",
        component: FormCadastroAtividade,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/editar-atividade/:atividadeId/encontros",
        name: "editar-encontros-atividade",
        component: FormCadastroEncontro,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/editar-noticia/:noticiaId",
        name: "editar-noticia",
        component: EditarNoticia,
        props: (route) => ({
          acaoId: route.params.id,
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/tarefas/:tarefaId",
        name: "acao-tarefas-view",
        component: TarefaView,
        props: (route) => ({
          tarefaId: route.params.tarefaId,
          ...route.params,
        }),
      },
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "login",
        component: LoginSigaaView,
      },
      {
        path: "autenticacao-sigaa",
        name: "autenticacao-sigaa",
        component: LoginSigaaView,
      },
      {
        path: "autenticacao-gex",
        name: "autenticacao-gex",
        component: loginGexView,
      },
      // Junto com as outras rotas de login
      {
        path: "/recuperar-senha",
        name: "recuperar-senha",
        component: EsqueciMinhaSenhaGex, // mesmo componente, ele já lida com o token
      },
      {
        path: "/recuperar-senha-perfil",
        name: "recuperar-senha-perfil",
        component: EsqueciMinhaSenhaGex, // mesmo componente, ele já lida com o token
      },
      {
        path: "/alterar-email",
        name: "alterar-email",
        component: EditarEmail,
      },
    ],
  },
  {
    name: "cadastro",
    path: "/cadastro",
    component: CadastroView,
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    redirect: "/",
  },
];

// Função para verificar se o usuário é coordenador
function checkCoordenador(to, from, next) {
  try {
    const userInfo = userInfos.getUserInfos();

    if (!userInfo || !userInfo.scope) {
      // Se não há informações do usuário, redireciona para a rota anterior
      next(from.path || "/");
      return;
    }

    const userScope = userInfo.scope;
    const isCoordenador = userScope.split(" ").includes("SCOPE_COORDENADOR");

    if (isCoordenador) {
      // Se é coordenador, permite o acesso
      next();
    } else {
      // Se não é coordenador, redireciona para a rota anterior
      next(from.path || "/");
    }
  } catch (error) {
    console.error("Erro ao verificar permissão de coordenador:", error);
    // Em caso de erro, redireciona para a rota anterior
    next(from.path || "/");
  }
}

function checkUsuarioPrex(to, from, next) {
  try {
    const userInfo = userInfos.getUserInfos();

    if (!userInfo || !userInfo.scope) {
      // Se não há informações do usuário, redireciona para a rota anterior
      next(from.path || "/");
      return;
    }

    const userScope = userInfo.scope;
    const isPrex = userScope.split(" ").includes("SCOPE_PREX");

    if (isPrex) {
      // Se é usuário PREX, permite o acesso
      next();
    } else {
      // Se não é usuário PREX, redireciona para a rota anterior
      next(from.path || "/");
    }
  } catch (error) {
    console.error("Erro ao verificar permissão de usuário PREX:", error);
    // Em caso de erro, redireciona para a rota anterior
    next(from.path || "/");
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const withoutAuthorization = [
  "login",
  "autenticacao-gex",
  "autenticacao-sigaa",
  "cadastro",
  "recuperar-senha",
  "verificacao-pin",
  // Rotas públicas
  "home",
  "home-page",
  "resultados",
  "noticias",
  "atividades",
  "Atividades",
  "vagas",
  "VagasView",
  "VagasViewAcao",
  "home-noticia",
  "home-atividade",
  "NoticiaView",
  "AtividadeView",
  "AcaoView",
  "acao-default",
  "acao-atividades",
  "acao-noticias",
  "acao-vagas",
  "acao-dashboard",
  "acao-informacoes",
  "alterar-email",
  "parcerias",
  "central-ajuda",
];

function validToken(token) {
  if (!token) return false; // Verifica se é null, undefined ou string vazia

  try {
    let decodedToken = jwtDecode(token);
    let dateNow = Date.now() / 1000;

    // Apenas verifica se a data de expiração é maior que agora
    if (decodedToken.exp > dateNow) {
      return true;
    }
    return false;
  } catch (error) {
    // Se o token estiver corrompido ou inválido, retorna false
    console.error("Erro ao decodificar token no router:", error);
    return false;
  }
}

router.beforeEach((to, from, next) => {
  let token = window.localStorage.getItem("auth_token");

  const isPublicRoute =
    withoutAuthorization.includes(to.name) ||
    withoutAuthorization.includes(to.path.replace(/^\//, "")) ||
    to.path === "/" ||
    to.path.startsWith("/vagas") ||
    to.path.startsWith("/Vaga") ||
    to.path.startsWith("/noticias") ||
    to.path.startsWith("/atividades") ||
    to.path.startsWith("/Parcerias");

  if (to.name === "login" && validToken(token)) {
    // next({ path: "/" });
  } else if (isPublicRoute || validToken(token)) {
    next();
  } else {
    next({ name: "login" });
  }
});

export default router;
